import { apiFetch } from './apiClient';

export function extractTenantIdFromLocation(hostname: string, path: string): string | null {
    // Strategy: subdomain (tenant.example.com) OR query param handled elsewhere OR /t/{id}/ path prefix
    const parts = hostname.split('.');
    if (parts.length > 2) {
        const possible = parts[0];
        if (possible && possible !== 'www') return possible; // treat as slug (not numeric id necessarily)
    }

    // Fix: rendere più tollerante la regex per il path /t/{id}
    const m = path.match(/\/t\/([^\/]+)/);
    if (m) return m[1];

    // Controlla URL params come backup (anche se questo è gestito principalmente in TenantContext)
    try {
        const url = new URL(window.location.href);
        const tenantId = url.searchParams.get('tenantId') || url.searchParams.get('tenantid');
        if (tenantId) return tenantId;
    } catch (_) {
        // Fallback silenziosamente se URL API non funziona
    }

    return null;
}

export async function resolveTenantId(candidate: string): Promise<string | null> {
    // no-op

    // Fix: supporta direttamente ID numerici senza chiamata API
    if (/^\d+$/.test(candidate)) {
        // no-op
        return candidate;
    }

    try {
        const res = await apiFetch(`/api/public/tenants/${candidate}`, { method: 'GET' });
        // no-op

        if (!res.ok) {
            // no-op
            return null;
        }

        const txt = await res.text();
        let data: any = null;
        try { data = JSON.parse(txt); } catch { data = null; }
        // no-op

        if (data && data.id) {
            // no-op
            return String(data.id);
        }

        // no-op
        return null;
    } catch (error) {
        // no-op
        return null;
    }
}
